import request from '@/utils/request'

export function listRechargeSetting(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/recharge.listRechargeConfigs',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

export function saveRechargeSetting(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/recharge.saveRechargeConfig',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

export function updateRechargeSetting(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/recharge.updateRechargeConfig',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

export function deleteRechargeSetting(id) {
  return new Promise((resolve, reject) => {
    request({
      url: '/recharge.deleteRechargeConfig',
      method: 'get',
      params: { id }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

